module.exports = __webpack_public_path__ + "img/poly-3.06b49332.png";